import React from "react";
import { FormHelperText, Typography } from "@mui/material";
import { FormGroup } from "./FormComponents";
import ComposerStepCard from "./ComposerStepCard";
import PublishScheduleOptions from "../scheduling/PublishScheduleOptions";
import type { StepProps } from "./StepComponents";

type EventPublishStepProps = StepProps & {
  formData: StepProps["formData"] & {
    publishMode?: "now" | "schedule";
    publishAt?: string;
    eventRecurrenceFrequency?: string;
  };
  errors: StepProps["errors"] & {
    publishAt?: string;
  };
};

const EventPublishStep: React.FC<EventPublishStepProps> = ({
  formData,
  errors,
  handleChange,
}) => {
  const hasRecurrence =
    formData.eventRecurrenceFrequency &&
    formData.eventRecurrenceFrequency !== "none";

  if (hasRecurrence) {
    return (
      <FormGroup style={{ marginBottom: 0 }}>
        <Typography variant="body2" color="text.secondary">
          Recurring events publish when you submit on the review step.
        </Typography>
      </FormGroup>
    );
  }

  return (
    <FormGroup style={{ marginBottom: 0 }}>
      <ComposerStepCard
        title="When should this go live?"
        subtitle="Post now or schedule for later."
      >
        <PublishScheduleOptions
          publishMode={formData.publishMode || "now"}
          publishAt={formData.publishAt || ""}
          onPublishModeChange={(mode) =>
            handleChange({ target: { name: "publishMode", value: mode } })
          }
          onPublishAtChange={(value) =>
            handleChange({ target: { name: "publishAt", value } })
          }
          hideHeading
        />
      </ComposerStepCard>
      {errors.publishAt && (
        <FormHelperText error sx={{ mt: 0.5 }}>
          {errors.publishAt}
        </FormHelperText>
      )}
    </FormGroup>
  );
};

export default EventPublishStep;
